<div class="home-container">
  <app-tefter-logo />
</div>
